document.addEventListener("DOMContentLoaded", function () {

  var form = document.getElementById("newsletter-form");
  if (!form) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;

    var email = emailInput.value;
    if (!email) return;

    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=PRmjW6", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2023-10-15"
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              email: email
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "KNWWY9"
              }
            }
          }
        }
      })
    })
    .then(response => {
      if (response.ok) {
        form.innerHTML = "<p>Thanks for subscribing!</p>";
      } else {
        console.error("Klaviyo error", response);
      }
    })
    .catch(error => console.error("Fetch error:", error));

  });

});
